import {translation} from "@2d-front-monorepo/core";
import {Icon} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, memo, ReactNode} from "react";
import {createAttachmentHref} from "../helpers/createAttachmentHref";
import {attachmentTypeLabel} from "../helpers/enumNaming";
import {AttachmentResult} from "../types/AttachmentResult";
import {AttachmentStatusComponent} from "./AttachmentStatusComponent";

interface EntityAttachmentProps {
	attachment: AttachmentResult;
	linkPrefix: string;
}

const EntityAttachment = memo(function EntityAttachment({attachment, linkPrefix}: EntityAttachmentProps): JSX.Element {
	const label = translation(attachmentTypeLabel(attachment.type));
	const href = createAttachmentHref(attachment, linkPrefix);

	return <li className="entity-documentation-entry">
		<span>
			<AttachmentStatusComponent attachment={attachment} small={false}/>
			<a href={href} target="_blank" download>
				<Icon icon="dowload-image"/>
				<span className="entity-documentation-entry__label">{label}</span>
			</a>
		</span>
		<span>
			{attachment.statusReason &&
                <span className="entity-documentation-entry__reason">
	                <strong>{translation(PermitTranslations.documentation__reason)}</strong>
					{attachment.statusReason}
				</span>
			}
			{/*{attachment.expires &&*/}
			{/*	<span className="entity-documentation-entry__expires"><strong>{translation(PermitTranslations.documentation__expires)}</strong> {Locale.getCurrent().formatDateTime(attachment.expires, DateTimeFormatDescription.Short)}</span>}*/}
			{attachment.additionalInformation &&
                <span className="entity-documentation-entry__comments">
	                <strong>{translation(PermitTranslations.documentation__comments)}</strong>
					{attachment.additionalInformation}
				</span>
			}
		</span>
	</li>;
});


export interface ExpiredAttachmentsComponentProps {
	attachments: AttachmentResult[];
	linkPrefix: string;
	className?: string;
	children?: ReactNode;
};

export default function ExpiredAttachmentsComponent({
	                                                    attachments,
	                                                    linkPrefix,
	                                                    className,
	                                                    children
                                                    }: ExpiredAttachmentsComponentProps): JSX.Element {
	if (attachments.length === 0) {
		return <></>;
	}

	return <dl className={"title-desc entity-documentation-list--expired " + className}>
		<dt>{translation(PermitTranslations.documentation__expired)}</dt>
		<dd>
			<ol className="entity-documentation-list">
				{attachments.map(((attachment, i) =>
					<EntityAttachment key={i} attachment={attachment} linkPrefix={linkPrefix}/>)
				)}
			</ol>
			{children}
		</dd>
	</dl>;
}
